export default "__VITE_ASSET__CGeFQwE1__"